import type { PostMetadataRecapGame } from '@/lib/db/types';
import { Trophy } from 'lucide-react';

interface Props {
  games: PostMetadataRecapGame[];
}

export function RoundGameRecap({ games }: Props) {
  if (!games.length) return null;

  return (
    <div className="mx-4 mb-3 space-y-2">
      <div className="text-[10px] font-extrabold tracking-[0.15em] text-gold-deep">ROUND HIGHLIGHTS</div>
      {games.map((g, i) => (
        <div key={`${g.format_id}-${i}`} className="rounded-xl border border-line bg-paper px-3.5 py-3">
          <div className="flex items-center gap-2">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-navy text-gold">
              <Trophy size={14} />
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-bold text-navy">{g.label || g.type}</div>
              {g.summary && <div className="text-xs text-ink-soft">{g.summary}</div>}
            </div>
          </div>
          {g.standings && g.standings.length > 0 && (
            <div className="mt-2.5 space-y-1 border-t border-line pt-2">
              {g.standings.slice(0, 4).map((s, j) => (
                <div key={j} className="flex justify-between text-[11px]">
                  <span className="text-ink">{s.rank != null ? `${s.rank}. ` : ''}{s.name}</span>
                  <span className="font-semibold text-navy">{s.value}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
